import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=a4a2bf5a&scoped=true"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"
import style0 from "./CheckboxField.vue?vue&type=style&index=0&id=a4a2bf5a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a2bf5a",
  null
  
)

export default component.exports